export const getFileType = (url = "") => {
    const cleanUrl = url.split("?")[0].toLowerCase();
  
    if (cleanUrl.match(/\.(jpg|jpeg|png|gif|webp|svg)$/)) {
      return "image";
    }
  
    if (cleanUrl.endsWith(".pdf")) {
      return "pdf";
    }
  
    return "other";
  };
  